export default __webpack_public_path__ + "static/media/logo.74be6c09.png";